import * as React from "react";

interface Props {
  color1?: string;
  color2?: string;
  color3?: string;
}

export const FilaInscricaoIcon = (props: Props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      fill={props.color2 ? props.color2 : "#D1FADF"}
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke={props.color3 ? props.color3 : "#ECFDF3"}
      strokeWidth="8"
    />
    <g clipPath="url(#clip0_4566_13779)">
      <path
        d="M35.0856 16.0176C33.9228 16.0176 32.9205 16.8592 32.5195 18.0214C34.0431 18.7027 35.2058 20.1855 35.6068 21.9889C36.8497 21.7084 37.7719 20.5061 37.7719 19.0634C37.7719 17.3401 36.569 16.0176 35.0856 16.0176Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
      <path
        d="M37.5696 23.1514C37.0483 23.6323 36.4068 23.9529 35.6851 24.0731C35.5649 25.1552 35.1639 26.1571 34.5625 26.9586H39.0129C39.5743 26.9586 40.0153 26.5178 40.0153 25.9567V25.4758C40.0153 24.3937 38.8125 23.7124 37.5696 23.1514Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
      <path
        d="M33.3188 28C32.5169 28.7214 31.5146 29.1622 30.432 29.1622C30.3519 30.4046 29.991 31.5267 29.4297 32.4885H35.0429C35.6844 32.4885 36.2457 31.9675 36.2457 31.2862V30.8053C36.2056 29.4828 34.7622 28.6813 33.3188 28Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
      <path
        d="M28.1485 34.0919C27.0259 35.214 25.5023 35.8552 23.8985 35.8552C22.2547 35.8552 20.7311 35.1739 19.6085 34.0117C17.7641 34.8934 16 36.0155 16 37.6586V38.4201C16 39.3018 16.7217 39.983 17.5637 39.983H30.1131C30.9952 39.983 31.6768 39.2617 31.6768 38.4201V37.6987C31.6768 36.0155 29.9928 34.9335 28.1485 34.0919Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
      <path
        d="M23.8604 33.37C26.2297 33.37 28.1505 31.2528 28.1505 28.6411C28.1505 26.0293 26.2297 23.9121 23.8604 23.9121C21.491 23.9121 19.5703 26.0293 19.5703 28.6411C19.5703 31.2528 21.491 33.37 23.8604 33.37Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
      <path
        d="M30.3138 19.7842C28.8303 19.7842 27.5874 20.8662 27.2266 22.3891C28.71 23.3509 29.7926 24.9941 30.2336 26.8776C30.2737 26.8776 30.2737 26.8776 30.3138 26.8776C32.078 26.8776 33.5213 25.2746 33.5213 23.3109C33.5614 21.3872 32.118 19.7842 30.3138 19.7842Z"
        fill={props.color1 ? props.color1 : "#4CAF50"}
      />
    </g>
    <defs>
      <clipPath id="clip0_4566_13779">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(16 16)"
        />
      </clipPath>
    </defs>
  </svg>
);
